import { ROUTES } from "routes/constants";

const POLICY_EVENT_FIRED_SESSION_KEY = "ga:policy-event-fired";

const TERMINAL_ROUTE_PREFIXES = [ROUTES.DECISION.ROOT];
const TERMINAL_ROUTES: Set<string> = new Set([
    ROUTES.WELCOME_BACK,
    ROUTES.SESSION_EXPIRED,
    ROUTES.SOMETHING_WENT_WRONG,
    ROUTES.AUTHENTICATION_FAILED,
    ROUTES.UNCOMPLETED_APPLICATION_EXPIRED,
]);

export const markPolicyEventFiredInSession = () => {
    if (globalThis.window === undefined) {
        return;
    }

    globalThis.window.sessionStorage.setItem(POLICY_EVENT_FIRED_SESSION_KEY, "1");
};

export const hasPolicyEventFiredInSession = () => {
    if (globalThis.window === undefined) {
        return false;
    }

    return globalThis.window.sessionStorage.getItem(POLICY_EVENT_FIRED_SESSION_KEY) === "1";
};

export const isTerminalPage = (pathname: string) => {
    if (TERMINAL_ROUTES.has(pathname)) {
        return true;
    }

    return TERMINAL_ROUTE_PREFIXES.some((prefix) => pathname.startsWith(prefix));
};

export const canTrackAbandonment = ({ saveContId, pathname }: { saveContId: string | null; pathname: string }) => {
    if (!saveContId) {
        return false;
    }

    if (hasPolicyEventFiredInSession()) {
        return false;
    }

    return !isTerminalPage(pathname);
};
